import { Dialog, DialogContent } from "@mui/material";
import { Box } from "@mui/system";
import { Button } from "react-bootstrap";
import useTaskTimer from "../../../assets/hooks/UseTaskTimer";
import { Modal, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { createEntity, deleteCommentEntities } from "../../../apis/apiService";
import { useFetchIssueTimeSheetLogDetailsQuery, useFetchLogDetailsQuery } from "../../../slice/logdetailSlice";



const TimerPopup = ({ showTimerPopup, setShowTimerPopup }) => {
  const {
    timers,
    activeTimerId,
    isPaused,
    pauseTimer,
    resumeTimer,
    stopTimer,
    cancelTimer,
  } = useTaskTimer();

  return (
    <>
      <Dialog open={showTimerPopup} onClose={() => setShowTimerPopup(false)}>
        <DialogContent>
          {activeTimerId && (
            <>
              <p>Timer running for ID: {activeTimerId}</p>
              <p>
                Hours: {String(timers[activeTimerId]?.hours).padStart(2, "0")},
                Minutes:{" "}
                {String(timers[activeTimerId]?.minutes).padStart(2, "0")},
                Seconds:{" "}
                {String(timers[activeTimerId]?.seconds).padStart(2, "0")}
              </p>
              <Box display="flex" gap={2} mt={2}>
                <Button onClick={pauseTimer} disabled={isPaused}>
                  Pause
                </Button>
                <Button onClick={resumeTimer} disabled={!isPaused}>
                  Resume
                </Button>
                <Button
                  color="error"
                  onClick={() => {
                    stopTimer();
                    setShowTimerPopup(false);
                  }}
                >
                  Stop
                </Button>
                <Button
                  color="error"
                  onClick={() => {
                    cancelTimer();
                    setShowTimerPopup(false);
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
export default TimerPopup;


export function PauseNoteModal({ show, onClose, onUpdate }) {
  const [note, setNote] = useState("");
  const isValidNotes = note.trim().length > 0;
  const handleUpdate = () => {
    onUpdate(note.trim());
    setNote("");

    // setIsPaused((prev) => !prev);
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Notes.</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Control
          as="textarea"
          rows={3}
          placeholder="Enter reason for pausing..."
          value={note}
          onChange={(e) => setNote(e.target.value)}
        />
      </Modal.Body>

      <Modal.Footer>
        <button
          className=" add_btn"
          disabled={!isValidNotes}
          onClick={handleUpdate}
        >
          Update
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export const StopTimerModal = ({
  show,
  onClose,
  setShowTimers,
  login_user_id,
  task_id,
  project_id,
  getTimer,
  // timer_id,
  issue_id,
  timerDatas,
}) => {
  const [notes, setNotes] = useState("");
  const isValidNotes = notes.trim().length > 0;
  const [loading, setLoading] = useState(false);
  const { refetch } = useFetchLogDetailsQuery(task_id, { skip: !task_id,});
  const { refetch: issue_log_refetch } = useFetchIssueTimeSheetLogDetailsQuery(issue_id, { skip: !issue_id,});

  useEffect(() => {
    if (show && timerDatas) {
      setNotes("");
    }
  }, [show, timerDatas]);
  const timer_id = localStorage.getItem("new_timer_id");
  const handleUpdate = async () => {
    setLoading(true);
    const requestedData = {
      billing_type: timerDatas.billing_type,
      notes: notes,
      timer_id: timer_id,
    };
    try {
      const response = await createEntity("timer/create", requestedData);
      toast.success(response.message);
      if (response) {
        setNotes("");
        localStorage.removeItem("timer_id");
        localStorage.removeItem("new_timer_id");
        localStorage.removeItem("timer_data");
        localStorage.removeItem("showStopModalPending");
        onClose();
        await getTimer();
        if (task_id) {
          refetch();
        }
        if (issue_id) {
          issue_log_refetch();
        }
      }
    } 
    catch (err) {
      toast.error(err.message);
    } 
    finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deleteCommentEntities("timer/delete", timer_id);
      if (response) {
        localStorage.removeItem("timer_id");
        localStorage.removeItem("new_timer_id");
        localStorage.removeItem("timer_data");
        localStorage.removeItem("showStopModalPending");
        await getTimer();
        onClose();
        toast.success(response.message);
      }
    } 
    catch (error) {
      toast.error(error.message);
    } 
    finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} backdrop="static" centered>
      <Modal.Header>
        <p className=" text-capitalize">Timer has stopped.</p>
      </Modal.Header>

      <Modal.Body>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <strong>{timerDatas?.total_hours}</strong> Hours
          </div>
          <div>
            <div>
              <span className="">Starts</span>:
              <span>
                {dayjs(timerDatas?.start_time).format("DD/MM/YYYY hh:mm A")}
              </span>
            </div>
            <div>
              <span className="">Ends</span>:{" "}
              <span>
                {dayjs(timerDatas?.end_time).format("DD/MM/YYYY hh:mm A")}
              </span>
            </div>
          </div>
        </div>

        <Form>
          <Form.Group className="mb-3">
            <Form.Check
              inline
              type="radio"
              label="Billable"
              checked={timerDatas?.billing_type === "BILLABLE"}
              disabled
              readOnly
            />
            <Form.Check
              inline
              type="radio"
              label="Non-Billable"
              checked={timerDatas?.billing_type === "NON-BILLABLE"}
              disabled
              readOnly
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Notes</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter notes..."
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      
      <Modal.Footer className="d-flex justify-content-between">
        <button
          className=" cancel_btn"
          disabled={loading}
          onClick={handleDelete}
          title="Delete"
        >
          Delete
        </button>
        <button
          className=" add_btn"
          disabled={!isValidNotes || loading}
          onClick={handleUpdate}
        >
          Update
        </button>
      </Modal.Footer>
    </Modal>
  );
};
